export default __webpack_public_path__ + "static/media/pointActived.e4cf4948.svg";